<template>
  <div class="hot">
    <div class="hot-img">
      <img src="../assets/rm.png" />
      <div>热门产品</div>
    </div>
    <div class="hot-product" @mouseover="mouseOver" @mouseleave="mouseLeave">
      <ul ref="productListRef">
        <li v-for="item in HotProductList" :key="item.id">
          <a target="_blank" @click="jumpOutLink('/product-detail' ,{id: item.id})">
            <HotProductItem :key="item.id" :productItem="item" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import HotProductItem from "./HotProductItem";
import { getHotProduct } from "@/network/home";
import { getZjzwfwLegalLoginUrlSplice } from '@/constants/index.js'
import {jumpOutLink} from '@/util/common.js'

export default {
  components: {
    HotProductItem
  },
  data: function() {
    return {
      listQuery: {
        rankType: 1,
        pageNo: 1,
        pageSize: 10,
        districtId: 1
      },
      HotProductList: [],
      RemainderArry: [],
      totalPage: "",
      setTime: "",
      baseTargetUrl: require('../constants').JUMP_TARGET
    };
  },
  created() {
    this.initialHotProduct();
    this.setTime = this.timer();
    window.addEventListener('message', this.getDistrictId)
  },
  destroyed() {
    clearInterval(this.timer);
    window.removeEventListener('message', this.getDistrictId)
  },
  methods: {
    getDistrictId(e) {
      if (!e.data) {
        return
      }
      let parentAction = e.data.action;
      if (parentAction === "UPDATE_LOCATION") {
        var countyid = e.data.payload["COUNTYID"];
        if (countyid) {
          this.listQuery.districtId = countyid;
          this.$store.commit('changAreaId',countyid)
        }
        this.initialHotProduct()
      }
      if (parentAction === 'UPDATE_USER') {
        // 如果已经有ticket了，就不用再去政务网登录
        if (this.$store.state.ticket) {
          return
        }
        console.log('got update user')
        window.location.href = getZjzwfwLegalLoginUrlSplice()
      }
    },
    initialHotProduct() {
      getHotProduct(this.listQuery).then(res => {
        res = res.data;
        this.totalPage = res.totalPage;
        this.HotProductList = res.result.slice(0, 4);
        this.RemainderArry = res.result.slice(4);
      });
    },
    // 定时器
    timer() {
      return setInterval(() => {
        this.$refs["productListRef"].style.transform = `translateY(-120px)`;
        this.$refs["productListRef"].style.transition = `transform 1s`;
        setTimeout(() => {
          if (!this.$refs["productListRef"]) {
            return
          }
          this.$refs["productListRef"].style.transform = `translateY(0)`;
          this.$refs["productListRef"].style.transition = ``;
          this.HotProductList.shift();
          this.HotProductList.push(this.RemainderArry.shift());
          if (this.RemainderArry.length === 0) {
            if (this.listQuery.pageNo < this.totalPage) {
              this.listQuery.pageNo += 1;
            } else {
              this.listQuery.pageNo = 1;
            }
            // console.log(this.listQuery)
            getHotProduct(this.listQuery).then(res => {
              this.RemainderArry = res.data.result;
            });
          }
        }, 1000);
      }, 4000);
    },
    mouseOver() {
      clearInterval(this.setTime);
    },
    mouseLeave() {
      this.setTime = this.timer();
    },
    jumpOutLink(path, query) {
      const target = jumpOutLink(path, query)
      window.open(target)
    }
  }
};
</script>

<style scoped>
.hot {
  width: 49%;
}
.hot-img {
  display: flex;
}
.hot-img img {
  width: 28px;
  height: 28px;
}
.hot-img div {
  line-height: 28px;
  font-size: 20px;
  margin-left: 2px;
  color: #444444;
  font-weight: 500;
}
.hot-product {
  height: 360px;
  overflow: hidden;
  margin-top: 10px;
  border: 1px solid #edf0f3;
  border-radius: 4px;
}
</style>
